/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */ 

/* CUSTOM CONCRETE STUDIO */


/* OPEN EXTERNAL LINK IN NEW TAB */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
} 


/* PRODUCT ACCORDION */
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {

    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      let active = document.querySelectorAll(".accordion-div .accordion.active");
      for(let j = 0; j < active.length; j++){
        active[j].classList.remove("active");
        active[j].nextElementSibling.style.maxHeight = null;
      }
      this.classList.toggle("active");
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
if(acc[0]) {
  acc[0].click(); // aprire il primo accordion al caricamento della pagina
}

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  var product_contact_form = document.querySelector('.product_contact_form');
  var ProductForm = document.querySelector(".ProductFormWrapper");
  var product_contact_form__Alert = document.querySelector('.product_contact_form__Alert');

  var window_url = window.location.href;

  if(window_url.indexOf('contact_posted=true') >= 0) {
    if(product_contact_form__Alert){
    product_contact_form__Alert.innerHTML = " ";
    }
  };

  console.log(variant);
  if(ProductForm && product_contact_form) {
    if(variant.available) {
      ProductForm.classList.remove("show_contact_form");
      product_contact_form.classList.remove("show_contact_form");
    } else {

      var show_contact_form = true;
      var mainSelectId = ProductForm.querySelector('[name="id"]');
      if(mainSelectId) {
        var selectedElement = mainSelectId.options[mainSelectId.selectedIndex];
        var hide_notification_form = selectedElement.getAttribute('data-hide_notification_form');
        if(hide_notification_form == 'true') {
          show_contact_form = false;
        }
      }
      console.log(show_contact_form);
      if(show_contact_form) {
        ProductForm.classList.add("show_contact_form");
        product_contact_form.classList.add("show_contact_form");

        document.querySelector(".contact_form_variant_title").value = variant.title;
      } else {
        ProductForm.classList.remove("show_contact_form");
        product_contact_form.classList.remove("show_contact_form");
      }
    }
  }


});